export function getAuthHeaders(extra = {}) {
    const token = localStorage.getItem('token');
    return {
        'Accept': 'application/json',
        ...extra,
        ...(token ? { Authorization: `Bearer ${token}` } : {})
    };
}